const HIGH_LACTATE_ALERT_LOW = 1.5; // mmol/L
const HIGH_LACTATE_ALERT_HIGH = 6.0; // mmol/L
const HIGH_LACTATE_ALERT_STEP = 0.5; // mmol/L

export const HIGH_LACTATE_ALERT_DEFAULT_INDEX = 1; // 2.0 mmol/L

// from HIGH_LACTATE_ALERT_LOW to HIGH_LACTATE_ALERT_HIGH, respecting HIGH_LACTATE_ALERT_STEP
// e.g. 1.5, 2.0, 2.5, ..., 6.0
// always rounded to 1 decimal place
export const HIGH_LACTATE_ALERT_ITEMS = Array.from(
  {
    length:
      (HIGH_LACTATE_ALERT_HIGH - HIGH_LACTATE_ALERT_LOW) /
        HIGH_LACTATE_ALERT_STEP +
      1,
  },
  (_, i) => HIGH_LACTATE_ALERT_LOW + i * HIGH_LACTATE_ALERT_STEP,
).map(
  (value) =>
    ({
      label: `${value.toFixed(1)} mmol/L`,
      value,
    }) as const,
);

export const HIGH_LACTATE_ALERT_ITEMS_LABELS = HIGH_LACTATE_ALERT_ITEMS.map(
  (item) => item.label,
);

const HIGH_LACTATE_ALERT_DURATION_LOW = 30; // minutes
const HIGH_LACTATE_ALERT_DURATION_HIGH = 120; // minutes
const HIGH_LACTATE_ALERT_DURATION_STEP = 30; // minutes

export const HIGH_LACTATE_ALERT_DURATION_DEFAULT_INDEX = 1; // 60 minutes
// from HIGH_LACTATE_ALERT_DURATION_LOW to HIGH_LACTATE_ALERT_DURATION_HIGH, respecting HIGH_LACTATE_ALERT_DURATION_STEP and format to hours
// e.g 0.5, 1.0, 1.5, ..., 2.0
export const HIGH_LACTATE_ALERT_DURATION_ITEMS = Array.from(
  {
    length:
      (HIGH_LACTATE_ALERT_DURATION_HIGH - HIGH_LACTATE_ALERT_DURATION_LOW) /
        HIGH_LACTATE_ALERT_DURATION_STEP +
      1,
  },
  (_, i) =>
    HIGH_LACTATE_ALERT_DURATION_LOW + i * HIGH_LACTATE_ALERT_DURATION_STEP,
).map(
  (value) =>
    ({
      label: `${(value / 60).toFixed(1)} hours`,
      value,
    }) as const,
);

export const HIGH_LACTATE_ALERT_DURATION_ITEMS_LABELS =
  HIGH_LACTATE_ALERT_DURATION_ITEMS.map((item) => item.label);
